<path
    d="M9.00006 2.47345C9.00006 1.30318 10.7387 0.601469 11.6362 1.2439L41.3914 23.4854C42.2029 24.0663 42.2029 25.3635 41.3914 25.9444L11.6361 47.7562C10.7386 48.3985 9 47.6967 9 46.5264L9.00006 24.7149V2.47345Z"
    fill="white"
/>
